import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "App/store/rootReducer";
import { injectStore } from "App/common/Http";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // The socket instance and Google Maps objects are non-serialisable but
      // legitimately live in state; checking them on every action is pure cost.
      serializableCheck: false,
    }),
  devTools: process.env.REACT_APP_ENV !== "prod",
});

// Http.ts reads the auth token off the store. It cannot import the store
// directly (store -> slices -> apiThunk -> Http would be a cycle), so the
// reference is handed over once, here, after the store exists.
injectStore(store);

export type AppDispatch = typeof store.dispatch;
export type { RootState } from "App/store/rootReducer";

export default store;
